import PropTypes from 'prop-types'
import React from 'react'
import { observer } from 'mobx-react'

const EmbeddedEntityInput = ({ store, state, attr, label, EditForm, items }) => {
  state = state || store.cv.subentities[attr]
  items = items || store.cv.record.get(attr)

  return (
    <div className='form-group'>
      {
        label ? (<h5 htmlFor={attr} className='card-title'>{label}</h5>) : null
      }
      {
        <EditForm
          store={store}
          state={state}
          record={state.record}
          updateFormField={store.updateSubentityField.bind(store, state, items)}
          errors={state.errors}
        />
      }
      {
        state.errors.has('_global') && (
          <div className='alert alert-danger fade in'>
            <strong>{store.__('ERROR')}: </strong>
            {state.errors.get('_global')}
          </div>
        )
      }
    </div>
  )
}
EmbeddedEntityInput.propTypes = {
  EditForm: PropTypes.func.isRequired,
  attr: PropTypes.string.isRequired,
  items: PropTypes.object,
  label: PropTypes.string,
  state: PropTypes.object,
  store: PropTypes.object.isRequired
}
export default observer(EmbeddedEntityInput)
